import { IEntity, IPagedSearchParams } from '@pf/shared-common';
import {
    ContainerFragment,
    InventoryBundleFragment,
    PutAwayViewModelCreateBody,
    PutAwayViewModelRead,
    SlotFragment,
} from '@control-tower/platform-wms';

export type PutAwayRead = PutAwayViewModelRead & IEntity;
export type PutAwayCreate = PutAwayViewModelCreateBody;
export interface PutAwaySearchParams extends IPagedSearchParams {
    putAwayListId: string;
    search?: string;
}

export class PutAwayDto implements IEntity {
    constructor(data: Partial<PutAwayDto>) {
        Object.assign(this, data);
    }

    id!: string;
    putAwayBy?: string | null;
    putAwayListId?: string;
    inventoryBundle?: InventoryBundleFragment;
    container?: ContainerFragment;
    putAwayToSlot?: SlotFragment;
    createdDate?: string;
    modifiedDate?: string;
    isDeleted?: boolean;
}
